import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

import ActionIcon from '../ActionIcon'
import Button from '../Button'
import { Close } from '../Icons'

import TargetedEmails from './covers/TargetedEmails'

const COVERS = {
  TARGETED_EMAILS: 'targeted_emails',
}

const MAP_COVERS = {
  [COVERS.TARGETED_EMAILS]: TargetedEmails,
}

const getBorderColorByType = (type) => {
  if (type === 'warning') {
    return 'var(--warning-color)'
  }

  if (type === 'error') {
    return 'var(--negative-color)'
  }

  return 'var(--primary)'
}

function PopupMessages({
  className,
  title,
  message,
  boldInMessage,
  ctaText,
  ctaOnClick,
  cover,
  onClose,
  type,
}) {
  return (
    <div className={className} data-type={type}>
      {onClose && <ActionIcon className="close" onClick={onClose} Icon={Close} />}
      <MaybeRenderCover cover={cover} />
      {title && <span className="title">{title}</span>}
      {message && (
        <span className="message">
          <MaybeBoldSubstring text={message} substring={boldInMessage} />
        </span>
      )}
      {ctaText && ctaOnClick && (
        <div className="actions">
          <Button onClick={ctaOnClick} text={ctaText} />
        </div>
      )}
    </div>
  )
}

const MaybeBoldSubstring = ({ text, substring }) => {
  if (!substring) {
    return <span>{text}</span>
  }

  // Find the position of the substring within the original string
  const parts = text.split(new RegExp(`(${substring})`, 'i')) // Split by substring, case-insensitive

  return (
    <span>
      {parts.map((part, index) =>
        part.toLowerCase() === substring.toLowerCase() ? (
          <strong key={index}>{part}</strong> // Make substring bold
        ) : (
          <span key={index}>{part}</span> // Normal rendering
        )
      )}
    </span>
  )
}

function MaybeRenderCover({ cover }) {
  if (!cover || !MAP_COVERS[cover]) return null
  const CoverComponent = MAP_COVERS[cover]
  return (
    <span className="cover">
      <CoverComponent />
    </span>
  )
}

const PopupMessagesStyled = styled(PopupMessages)`
  max-width: 415px;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 30px;
  position: relative;
  background: var(--color-elevated);
  border-radius: 4px;
  border: 2px solid ${(props) => getBorderColorByType(props.type)};
  box-sizing: border-box;
  box-shadow: var(--color-elevated-shadow);
  .close {
    position: absolute;
    top: 16px;
    right: 16px;
  }
  .cover {
    margin-bottom: 20px;
  }
  .title {
    color: var(--color-text);
    font-weight: 700;
    font-size: 24px;
    margin-bottom: 20px;
    text-align: center;
  }
  .message {
    color: var(--color-text);
    font-weight: 400;
    font-size: 14px;
    text-align: center;
    line-height: 1.5;
  }
  .actions {
    margin-top: 20px;
  }
`

PopupMessagesStyled.propTypes = {
  className: PropTypes.string,
  title: PropTypes.string,
  message: PropTypes.string.isRequired,
  boldInMessage: PropTypes.string,
  ctaText: PropTypes.string,
  ctaOnClick: PropTypes.func,
  cover: PropTypes.oneOf(Object.values(COVERS)),
  onClose: PropTypes.func,
  type: PropTypes.oneOf(['success', 'warning', 'error', 'info']),
}

PopupMessagesStyled.COVERS = COVERS

export default PopupMessagesStyled
